module.exports = __webpack_public_path__ + "static/media/blue_place.84126d86.svg";